import { get, map } from 'lodash';
import { withdrawalsServices } from '../services';
import { formatDateToDisplay } from '../utils';

export const fetchAllWithdrawals = async (payload) => {
  try {
    const res = await withdrawalsServices.fetchAllWithdrawals(payload);
    const data = get(res, 'data.data', []);
    console.log(data, 'res');
    return map(data, (row, i) => ({
      id: row._id,
      result: i + 1,
      title: row.artist_name,
      dateinitiated: formatDateToDisplay(row.created_at),
      amount: row.amount,
      accountnumber: row.account_number,
      user_id: row.user_id,
    }));
  } catch (error) {
    console.log(error);
  }
};

